import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { RoleDAO } from '../../../../core/services/dao/roleDAO';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { VesselDAO } from '../../../../core/services/dao/vesselDAO';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { BoatOwnerDAO } from '../../../../core/services/dao/boatOwnerDAO';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { Observable } from 'rxjs/internal/Observable';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class VesselsResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private vesselDAO: VesselDAO,
    private roleDAO: RoleDAO,
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private boatOwnerDAO: BoatOwnerDAO,
    private waterBodyDAO: WaterBodyDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    let vesselResolve: Observable<any>;
    const los = route.queryParams.los;
    const status = route.queryParams.status;
    if (los) {
      vesselResolve = this.vesselDAO.loadVesselsByLosOrStatus(los);
    } else if (status) {
      vesselResolve = this.vesselDAO.loadVesselsByLosOrStatus(status);
    } else {
      vesselResolve = this.vesselDAO.load();
    }
    const ownerResolve = this.boatOwnerDAO.loadApprovedOwners();
    const waterResolve = this.waterBodyDAO.load();
    const mergeResolves = merge(vesselResolve, ownerResolve, waterResolve);
    return mergeResolves.pipe(
      take(3),
      map((data) => data),
    );
  }
}
